<template>
  <transition name="fade">
    <div class="image-preview-container" v-if="visible" ref="container">
      <div class="image-wrapper">
        <!-- 如果传入的是图片URL，显示图片 -->
        <img v-if="imageUrl && !qrcodeData" :src="imageUrl" alt="预览图片" class="preview-image" />
        <!-- 如果传入的是二维码数据，显示二维码 -->
        <div v-if="qrcodeData" class="qrcode-wrapper">
          <qrcode-vue :size="300" :value="qrcodeData.url" :logo="qrcodeData.logo" :bgColor="qrcodeData.bgColor"
            :fgColor="qrcodeData.fgColor">
          </qrcode-vue>
          <!-- <p v-if="qrcodeData.title" class="qrcode-title">{{ qrcodeData.title }}</p> -->
        </div>
        <div class="close-button" @click="closeDialog">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import QrcodeVue from 'qrcode-vue'

export default {
  name: 'ShowImage',
  components: {
    QrcodeVue
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    },
    // 新增二维码数据属性
    qrcodeData: {
      type: Object,
      default: null
      // 格式: { url: '', logo: '', bgColor: '', fgColor: '', title: '' }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        console.log("--- ~ props.qrcodeData:---", this.qrcodeData)
        this.$nextTick(() => {
          // 将组件移动到 body 下
          if (this.$refs.container) {
            document.body.appendChild(this.$refs.container);
          }
        });
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    }
  },
  beforeDestroy() {
    // 组件销毁前移除元素
    if (this.$refs.container && this.$refs.container.parentNode) {
      this.$refs.container.parentNode.removeChild(this.$refs.container);
    }
  }
}
</script>

<style scoped>
.image-preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  /* 大幅提高层级，确保在最顶层 */
}

/* 添加渐显渐隐效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.image-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: zoom-in 0.3s ease;
}

@keyframes zoom-in {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.preview-image {
  max-width: 80%;
  max-height: 80vh;
  object-fit: contain;
}

.qrcode-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 20px;
  border-radius: 8px;
}

.qrcode-title {
  margin-top: 15px;
  color: #666;
  font-size: 14px;
  text-align: center;
}

.close-button {
  position: absolute;
  bottom: -50px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.close-button i {
  font-size: 20px;
  color: #333;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 1);
}
</style>